import {
  NounPhrase,
  PrepositionalPhrase, RenderUnit,
  Sentence,
  VerbPhrase,
  Word
} from "./grammar";

const THE = Word.simple("the", {definite: true});
const A = Word.simple("a", {indefinite: true})

function h(text: string): RenderUnit {
  return {text, highlight: true};
}

function w(text: string): RenderUnit {
  return {text, highlight: false};
}

// "A hungry tiger chased a mouse in the forest."
export const CHASE = new Sentence(
  new NounPhrase(
    A,
    Word.simple("hungry", {highlight: true}),
    Word.simple("tiger", {highlight: true, genderSuffix: "-en"}),
    null,
    Word.simple("one individual of"),
  ),
  new VerbPhrase(
    null,
    Word.simple("chase", {highlight: true, verbConjugation: "d"}),
  ),
  new NounPhrase(
    A,
    null,
    Word.simple("mouse", {highlight: true}),
    null,
    Word.simple("one individual of"),
  ),
  new PrepositionalPhrase(
    Word.simple("in"),
    new NounPhrase(
      THE,
      null,
      Word.simple("forest", {highlight: true, genderSuffix: "-a", nounInflection: "-e"}),
      null,
      null,
    ),
    Word.simple("located"),
  ),
  {
    russian: {
      units: [h("голодный"), h("тигр"), h("преследовал"), h("крысу"), w("в"), h("лесу")],
      spaces: true,
      period: ".",
    },
    russianTranslit: {
      units: [h("golodnyy"), h("tigr"), h("presledoval"), h("krysu"), w("v"), h("lesu")],
      spaces: true,
      period: "",
    },
    french: {
      units: [w("un"), h("tigre"), h("affamé"), w("a"), h("chassé"), w("un"), h("rat"), w("dans"), w("la"), h("forêt")],
      spaces: true,
      period: ".",
    },
    chinese: {
      units: [w("一头"), h("饥饿"), w("的"), h("老虎"), w("在"), h("森林"), w("里"), h("追赶着"), w("一只"), h("老鼠")],
      spaces: false,
      period: "。",
    },
    chineseTranslit: {
      units: [w("yī"), w("tóu"), h("jī'è"), w("de"), h("lǎohǔ"), w("zài"), h("sēnlín"), w("lǐ"), h("zhuīgǎnzhe"), w("yī"), w("zhī"), h("lǎoshǔ")],
      spaces: true,
      period: "",
    },
    hindi: {
      units: [w("एक"), h("भूखा"), h("बाघ"), h("जंगल"), w("में"), w("एक"), h("चूहे"), w("के"), h("पीछे दौड़ा")],
      spaces: true,
      period: "।",
    },
    hindiTranslit: {
      units: [w("ek"), h("bhūkhā"), h("bāgh"), h("jaṅgal"), w("mẽ"), w("ek"), h("cūhe"), w("ke"), h("pīche dauṛā")],
      spaces: true,
      period: ""
    },
  }
);
